import React from 'react';
import { useParams } from 'react-router-dom';
import './ProductionSubpage.css'; // Re-using styles for consistency

const serviceDetails = {
  aanittaminen: {
    title: 'Äänittäminen',
    description: 'Tarkempaa tietoa äänittämispalveluista tulossa pian.',
  },
  aanisuunnittelu: {
    title: 'Äänisuunnittelu',
    description: 'Tarkempaa tietoa äänisuunnittelupalveluista tulossa pian.',
  },
  'voice-over': {
    title: 'Voice over',
    description: 'Tarkempaa tietoa voice over -palveluista tulossa pian.',
  },
  radiomainokset: {
    title: 'Radiomainokset',
    description: 'Tarkempaa tietoa radiomainospalveluista tulossa pian.',
  },
  tuotantopaallikko: {
    title: 'Tuotantopäällikkö',
    description: 'Tarkempaa tietoa tuotantopäällikköpalveluista tulossa pian.',
  },
};

const TuotantopalveluSubpage = () => {
  const { serviceId } = useParams();
  const service = serviceDetails[serviceId] || { title: 'Palvelua ei löydy', description: '' };

  return (
    <div className="production-subpage-container">
      <h1>{service.title}</h1>
      <p>{service.description}</p>
    </div>
  );
};

export default TuotantopalveluSubpage;